import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Company, CompanyEnum } from '../../models/company.model';
import { AlpCourseStartDatesComponent } from './alp-course-start-dates/alp-course-start-dates.component';
import { PositivelyLanguagesCourseStartDatesComponent } from './positively-languages-course-start-dates/positively-languages-course-start-dates.component';
import { CourseStartDate } from '../../models/pricelist-course-start-date.model';

@Component({
  standalone: true,
  imports: [CommonModule, PositivelyLanguagesCourseStartDatesComponent, AlpCourseStartDatesComponent],
  selector: 'lx-price-lists-portal-course-start-dates',
  templateUrl: './course-start-dates.component.html',
  styleUrls: ['./course-start-dates.component.scss', './print-course-start-dates.component.scss'],
})
export class CourseStartDatesComponent implements OnInit {
  @Input() courseStartDates: CourseStartDate[] = [];
  @Input() company: Company = CompanyEnum.KIL;

  title = '';

  companyEnum = CompanyEnum;

  ngOnInit(): void {
    this.title = this.company === CompanyEnum.KIL ? 'Course length (weeks) & start dates' : 'Course start dates';
  }
}
